// 1px hairline that fades to transparent at both ends. Pair two stops at
// 13.47%/86.59% (Figma node 4030:12572) so the fade reaches full opacity
// across the middle ~73% of the line. Position via `className`.

import { cn } from "@/lib/utils";

export interface FadeLineProps {
  orientation?: "horizontal" | "vertical";
  /** Solid color of the line's middle section. */
  color?: string;
  /** Same color with alpha 0 — used for the fade endpoints. */
  transparentColor?: string;
  className?: string;
}

export function FadeLine({
  orientation = "horizontal",
  color = "#E5E6E6",
  transparentColor = "rgba(229, 230, 230, 0)",
  className,
}: FadeLineProps) {
  const direction = orientation === "horizontal" ? "to right" : "to bottom";
  return (
    <div
      aria-hidden
      className={cn(
        "pointer-events-none absolute",
        orientation === "horizontal" ? "h-px" : "w-px",
        className
      )}
      style={{
        background: `linear-gradient(${direction}, ${transparentColor} 0%, ${color} 13.47%, ${color} 86.59%, ${transparentColor} 100%)`,
      }}
    />
  );
}
